import qs from "qs";
import http from "../http";

function createInterface(payload) {
  return http("POST", `${window.API_URL}/interface`, payload);
}

function getInterfaces(payload) {
  return http("GET", `${window.API_URL}/interfaces?${qs.stringify(payload)}`);
}

// 대시보드 끝
function getInterfaceDetail(payload) {
  return http("GET", `${window.API_URL}/interface/${payload.id}`);
}

function deleteInterface(payload) {
  return http("DELETE", `${window.API_URL}/interface/${payload.interfaceId}`);
}

function getSeparatedProjects(payload) {
  return http(
    "GET",
    `${window.API_URL}/separatedProjects?${qs.stringify(payload)}`
  );
}

export default {
  getSeparatedProjects,
  createInterface,
  getInterfaces,
  getInterfaceDetail,
  deleteInterface,
};
